import { Display } from '@guardian/types/Format';
export const decideDisplay = (CAPI) => {
    if (CAPI.isImmersive)
        return Display.Immersive;
    if (CAPI.pageType.hasShowcaseMainElement)
        return Display.Showcase;
    return Display.Standard;
};
